module.exports = __webpack_public_path__ + "assets/INFRASTRUKTURE.90d5bf41.svg";